function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import SearchBox from "../forms/search-box";
var number = PropTypes.number,
    string = PropTypes.string,
    func = PropTypes.func,
    oneOf = PropTypes.oneOf,
    bool = PropTypes.bool;

var ArrowSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrowSelect, _React$Component);

  var _super = _createSuper(ArrowSelect);

  function ArrowSelect() {
    var _this;

    _classCallCheck(this, ArrowSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (evnt) {
      switch (evnt.key) {
        case "ArrowUp":
          evnt.preventDefault();
          return typeof _this.props.onArrow === "function" ? _this.props.onArrow(Math.max(_this.props.selectedIndex - 1, 0)) : undefined;

        case "ArrowDown":
          evnt.preventDefault();
          return typeof _this.props.onArrow === "function" ? _this.props.onArrow(Math.min(_this.props.selectedIndex + 1, _this.props.maxIndex)) : undefined;

        case "Enter":
          evnt.preventDefault();
          return typeof _this.props.onEnter === "function" ? _this.props.onEnter() : undefined;

        case "Escape":
          return typeof _this.props.onEscape === "function" ? _this.props.onEscape(evnt) : undefined;

        default:
          if (evnt.key !== "Shift") {
            var query = evnt.currentTarget.value;
            return typeof _this.props.onType === "function" ? _this.props.onType(query, evnt) : undefined;
          }

      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (evnt) {
      var query = _this.arrowSelectInput != null ? _this.arrowSelectInput.value : undefined;

      if (_.isEmpty(query) && evnt.key === "Backspace") {
        return typeof _this.props.onEmpty === "function" ? _this.props.onEmpty() : undefined;
      }
    });

    return _this;
  }

  _createClass(ArrowSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.type === "search") {
        return /*#__PURE__*/React.createElement(SearchBox, {
          ref: function ref(e) {
            return _this2.arrowSelectInput = e;
          },
          className: this.props.className,
          placeholder: this.props.placeholder,
          defaultValue: this.props.defaultValue,
          focusOnMount: this.props.focusOnMount,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur,
          onKeyDown: this.handleKeyDown,
          onKeyUp: function onKeyUp(value, e) {
            return _this2.handleKeyPress(e);
          }
        });
      } else {
        return /*#__PURE__*/React.createElement("input", {
          type: "text",
          ref: "arrowSelectInput",
          className: this.props.className,
          placeholder: this.props.placeholder,
          defaultValue: this.props.defaultValue,
          onKeyUp: this.handleKeyPress,
          onKeyDown: this.handleKeyDown,
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur
        });
      }
    }
  }]);

  return ArrowSelect;
}(React.Component);

_defineProperty(ArrowSelect, "displayName", "ArrowSelect");

_defineProperty(ArrowSelect, "propTypes", {
  type: oneOf(["text", "search"]),
  placeholder: string,
  selectedIndex: number,
  maxIndex: number,
  onType: func,
  onEnter: func,
  onArrow: func,
  onEscape: func,
  onEmpty: func,
  onFocus: func,
  onBlur: func,
  focusOnMount: bool
});

export { ArrowSelect as default };